/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Video_PlayerInputs */

const en_vault_video_player = /** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Video Player`)
};

const id_vault_video_player = /** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemutar Video Premium`)
};

/** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */
const es_vault_video_player = en_vault_video_player;

/** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */
const fr_vault_video_player = en_vault_video_player;

/** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */
const de_vault_video_player = en_vault_video_player;

/** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */
const ja_vault_video_player = en_vault_video_player;

/** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */
const zh_vault_video_player = en_vault_video_player;

/** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */
const ar_vault_video_player = en_vault_video_player;

/** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */
const it_vault_video_player = en_vault_video_player;

/** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */
const ru_vault_video_player = en_vault_video_player;

/** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */
const pt_vault_video_player = en_vault_video_player;

/** @type {(inputs: Vault_Video_PlayerInputs) => LocalizedString} */
const ko_vault_video_player = en_vault_video_player;

/**
* | output |
* | --- |
* | "Premium Video Player" |
*
* @param {Vault_Video_PlayerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_video_player = /** @type {((inputs?: Vault_Video_PlayerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Video_PlayerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_video_player(inputs)
	if (locale === "es") return es_vault_video_player(inputs)
	if (locale === "fr") return fr_vault_video_player(inputs)
	if (locale === "de") return de_vault_video_player(inputs)
	if (locale === "ja") return ja_vault_video_player(inputs)
	if (locale === "zh") return zh_vault_video_player(inputs)
	if (locale === "ar") return ar_vault_video_player(inputs)
	if (locale === "id") return id_vault_video_player(inputs)
	if (locale === "it") return it_vault_video_player(inputs)
	if (locale === "ru") return ru_vault_video_player(inputs)
	if (locale === "pt") return pt_vault_video_player(inputs)
	return ko_vault_video_player(inputs)
});